import React from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

import { PatientChartContextProvider } from 'lib/context/PatientChartContext/PatientChartContextProvider';
import { usePatients } from 'lib/hooks/queries/patients/usePatients';
import usePageTitle from 'lib/hooks/usePageTitle';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import ExportAction from './components/ExportAction';
import PatientModal from './components/PatientModal';
import { defaultColumns, defaultFilters } from './lib/helper';

export default function PatientCharts() {
  usePageTitle('Charts');
  const navigate = useNavigate();
  const { id } = useParams();

  if (id)
    return (
      <PatientChartContextProvider>
        <Outlet />
      </PatientChartContextProvider>
    );

  const onSelectRow = (data, event) => {
    if (event?.column?.colId === 'tagLinks') return;
    navigate(`/portal/charts/${data.id}`);
  };

  return (
    <AgTablePage
      ModalComponent={PatientModal}
      defaultColumns={defaultColumns}
      defaultFilters={defaultFilters}
      useData={usePatients}
      onSelectRow={onSelectRow}
      rowStyle={{ cursor: 'pointer' }}
      headerActions={ExportAction}
      name="patients"
      title="Charts"
    />
  );
}
